// Band content — ΤΑΞΙΔΙΩΤΕΣ / Travelers gr

export const BAND = {
  nameGr: "ΤΑΞΙΔΙΩΤΕΣ",
  nameEn: "Travelers gr",
  handle: "Taxidiotes gr",
  tagline: "Χριστιανική μουσική & τραγούδια · Θεσσαλονίκη",
  city: "ΘΕΣΣΑΛΟΝΙΚΗ",
  since: "GOSPEL MUSIC BAND",
  intro:
    "Το μουσικό σχήμα ΤΑΞΙΔΙΩΤΕΣ αποτελείται από αναγεννημένους Χριστιανούς μουσικούς που προσφέρουν το μουσικό τους ταλέντο στον Θεό, στην υμνολογία και τη δοξολογία στο πρόσωπο του Ιησού Χριστού.",
};

export const CHAPTERS = [
  {
    no: "01",
    title: "Η Αποστολή",
    text: "Είμαστε αναγεννημένοι Χριστιανοί μουσικοί από τη Θεσσαλονίκη. Δεν παίζουμε για εμάς — προσφέρουμε το ταλέντο μας ως θυσία λατρείας, με έναν σκοπό: να δοξαστεί το όνομα του Ιησού Χριστού.",
  },
  {
    no: "02",
    title: "Ο Ήχος",
    text: "Gospel με ελληνική ψυχή. Ζεστές κιθάρες, φωνές που ενώνονται, ρυθμός που ταξιδεύει από την παραλία της Θεσσαλονίκης μέχρι την καρδιά κάθε ανθρώπου που ακούει.",
  },
  {
    no: "03",
    title: "Το Ταξίδι",
    text: "Ταξιδιώτες σε αυτή τη ζωή, με προορισμό την αιωνιότητα. Κάθε εμφάνιση είναι ένα βήμα του δρόμου — μια πρόσκληση να ταξιδέψουμε μαζί προς το φως.",
  },
];

export const PSALM = [
  "Αινείτε τον Κύριο.",
  "Αινείτε τον Θεό στο αγιαστήριο Του.",
  "Αινείτε τον με ήχο σαλπιγγος.",
  "Αινείτε τον με ψαλτήρι και κιθάρα.",
  "Αινείτε τον με τύμπανο και χοροστασία.",
  "Αινείτε τον με χορδές και όργανο.",
  "Κάθε πνοή ας αινεί τον Κύριο. Αλληλούια.",
];

export const YOUTUBE_ID = "tr7-o7hzj_0";
export const YOUTUBE_URL = "https://youtu.be/tr7-o7hzj_0";

export const VIDEO_FILE = "taxidiotes-audio.mp3";

export const PHONE_DISPLAY = "694 420 2981";
export const PHONE_TEL = "+306944202981";

export const SHOWS = [
  { date: "12 ΣΕΠ 2026", city: "Θεσσαλονίκη", venue: "Νέα Παραλία · Live Worship", status: "ΕΙΣΟΔΟΣ ΕΛΕΥΘΕΡΗ" },
];

export const THESS_SLIDES = [
  { url: "https://images.unsplash.com/photo-1665252142324-10c27d1d210c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600", name: "Λευκός Πύργος" },
  { url: "https://images.unsplash.com/photo-1632074870740-8cdcba2177ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600", name: "Νέα Παραλία" },
  { url: "https://images.unsplash.com/photo-1551189654-7a5ac7381f8b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600", name: "Άνω Πόλη · Θέα" },
  { url: "https://images.unsplash.com/photo-1504478855730-6d32c20fa165?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600", name: "Ομπρέλες · Ζογγολόπουλος" },
];

export const SOCIALS = [
  { label: "YouTube", href: "https://www.youtube.com/@TravelersGR", handle: "@TravelersGR" },
  { label: "Instagram", href: "#", handle: "@taxidiotes.gr" },
  { label: "Facebook", href: "#", handle: "Taxidiotes gr" },
  { label: "Spotify", href: "#", handle: "Travelers gr" },
];

export const GALLERY = [
  { src: "band-live-park.jpg", caption: "Live στη Νέα Παραλία" },
  { src: "band-group-5.jpg", caption: "Η παρέα των Ταξιδιωτών" },
  { src: "band-trio.jpg", caption: "Μαζί στη λατρεία" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1763567966641-2fd8676612b5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  poster:
    (process.env.PUBLIC_URL || "") + "/images/band-boat-harbor.jpg",
  waterfront: "https://images.unsplash.com/photo-1763567966641-2fd8676612b5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  worship: "https://images.unsplash.com/photo-1438232992991-995b7058bbb3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  guitar: "https://images.unsplash.com/photo-1676027080800-cda8b8e02317?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  crowd: "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};
